import React from 'react';
import Sidebar from '../../components/common/Sidebar';
import Navbar from '../../components/common/Navbar';
import EarlyLeaveForm from '../components/forms/EarlyLeaveForm';
import '../../wrms/css/wrms.css';

const EarlyLeavePage = () => (
  <div className="d-flex wrms-page">
    <Sidebar />
    <div className="flex-grow-1">
      <Navbar />
      <div className="wrms-container">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wrms-page-header">
            <div className="wrms-breadcrumb">Requests · <span>Early Leave Request</span></div>
            <h1 className="wrms-page-title">Apply for Early Leave</h1>
            <p className="wrms-page-subtitle">Submit an early leave request. Does not deduct from your leave balance.</p>
          </div>
          <div className="wrms-card" style={{ overflow: 'hidden' }}>
            <EarlyLeaveForm />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default EarlyLeavePage;
